// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-categories/styles.less
// module id = 1184
// module chunks = 10